import { render, staticRenderFns } from "./process-datasource-storage-period-form.vue?vue&type=template&id=672ffa3e"
import script from "./process-datasource-storage-period-form.vue?vue&type=script&lang=js"
export * from "./process-datasource-storage-period-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports